module.exports = __webpack_public_path__ + "images/resume_searches/icon-full-f8c5720c64bca40b61298a82f376a465.svg";